import Vue from "vue";
import Vuex from "vuex";

import * as types from "./mutation-types";

const context = require.context("./modules", true, /[A-Za-z0-9-_,\s]+\.js$/i);
const modules = {};

context.keys().forEach((file) => {
  const moduleName = file.match(/([A-Za-z0-9-_]+)\./i)[1];

  modules[moduleName] = context(file).default || context(file);

  modules[moduleName].namespaced = true;
});

Vue.use(Vuex);

export const state = {
  count: 0,
};

export const getters = {
  loading: (state) => state.count > 0,
};

export const mutations = {
  [types.INCREMENT_REQUEST](state) {
    state.count++;
  },
  [types.DECREMENT_REQUEST](state) {
    state.count--;
  },
};

export const actions = {};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules,
});
